import { render, staticRenderFns } from "./LabCompany.vue?vue&type=template&id=013f9975"
import script from "./LabCompany.vue?vue&type=script&lang=js"
export * from "./LabCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports